import { render, staticRenderFns } from "./ConfigStatusTable.vue?vue&type=template&id=134f0d64&scoped=true"
import script from "./ConfigStatusTable.vue?vue&type=script&lang=js"
export * from "./ConfigStatusTable.vue?vue&type=script&lang=js"
import style0 from "./ConfigStatusTable.vue?vue&type=style&index=0&id=134f0d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134f0d64",
  null
  
)

export default component.exports